
import React, { useEffect } from 'react';
import { useOfflineQueue } from '../../stores/useOfflineQueue';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';
import { clsx } from 'clsx';

export const SyncIndicator: React.FC = () => {
    const { isOnline, isSyncing, queueSize, initialize } = useOfflineQueue();

    useEffect(() => {
        initialize();
    }, []);

    if (isOnline && queueSize === 0 && !isSyncing) return null;

    return (
        <div className={clsx(
            "fixed top-safe left-1/2 -translate-x-1/2 mt-2 z-50 px-3 py-1.5 rounded-full shadow-lg flex items-center gap-2 text-xs font-bold transition-all animate-slide-down",
            !isOnline ? "bg-stone-800 text-stone-200" :
                isSyncing ? "bg-blue-600 text-white" :
                    "bg-amber-100 text-amber-800"
        )}>
            {!isOnline && (
                <>
                    <WifiOff size={12} />
                    <span>Offline ({queueSize})</span>
                </>
            )}

            {isOnline && isSyncing && (
                <>
                    <RefreshCw size={12} className="animate-spin" />
                    <span>Syncing {queueSize}...</span>
                </>
            )}

            {isOnline && !isSyncing && queueSize > 0 && (
                <>
                    <Wifi size={12} />
                    <span>Pending ({queueSize})</span>
                </>
            )}
        </div>
    );
};
